import { Routes } from '@angular/router';
import { RestaurantDetailsPageComponent } from './components/restaurant-details-page/restaurant-details-page.component';

export const routes: Routes = [
  {
    path: '',
    component: RestaurantDetailsPageComponent
  }
];
